import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-performance-row',
    templateUrl: './performance-row.component.html',
    styleUrls: ['./performance-row.component.scss'],
    standalone: false
})
export class PerformanceRowComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
